<template>
  <div class="bj-tooltip">
    <el-tooltip
      :placement="placement"
      :effect="$theme.tooltipKey()"
      :content="content"
      popper-class="common-panel-tooltip-box">
      <template slot="content">
        <slot name="content"></slot>
      </template>
      <template>
        <slot></slot>
      </template>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    content: {
      type: String,
      required: false
    },
    placement: {
      type: String,
      required: false,
      default: 'top-start'
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style scoped lang="scss"></style>
